<template>
  <div id="person-slider">
    <splide :options="options">
      <splide-slide v-for="(slide, index) in slides" :key="index">
        <div
          class="h-100 w-100 position-relative overflow-hidden background-blue"
        >
          <div class="row h-100 align-content-start">
            <div
              class="col-12 col-md-6 slide-img-col slide-img-dt"
              v-bind:style="slide.mainImgStyleDt"
            >
              <img
                class="img-fluid d-md-none"
                :src="slide.mainImgSrcMb"
                :alt="slide.mainImgAlt"
              />
            </div>
            <div class="col-12 col-md-6 background-blue">
              <div class="p-4 p-lg-5 pr-md-5">
                <div
                  class="reference-text-container d-flex flex-column text-white"
                >
                  <h3 class="font-weight-bold mb-md-3 subheadline">
                    {{ slide.headline }}
                  </h3>
                  <p class="mb-4 reference-text">
                    {{ slide.referenceText }}
                  </p>
                </div>
                <div class="d-flex slider-person-details">
                  <div class="slider-person-img">
                    <img
                      width="100"
                      height="120"
                      :src="`${slide.personImgSrc}`"
                      :alt="`${slide.personName}`"
                    />
                  </div>
                  <p
                    class="
                      font-weight-bold
                      text-white
                      pl-3
                      mb-0
                      person-slider-info
                    "
                  >
                    <span v-html="slide.personName"></span>
                    <br />
                    <span v-html="slide.personTitle"></span>
                    <br />
                    <span v-html="slide.personCompany"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </splide-slide>
    </splide>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      options: {
        type: "slide",
      },
      slides: [
        {
          mainImgSrcMb: "images/banner_references1-mb.jpg",
          mainImgStyleDt: {
            backgroundImage: "url('images/banner_references1.png')",
          },
          mainImgAlt: "Neubauprojekt Kraftwerk Datteln",
          headline: "Energieversorgung",
          referenceText: `Als international tätiges Energieunternehmen müssen
                  Baumaßnahmen in unserem Auftrag auf unseren Baustellen und bei
                  den Fertigern den einschlägigen Normen entsprechen und adäquat
                  überwacht werden. Die Basis unserer Qualitätssicherung sind
                  normenkonforme Inspektionen. Diese Anforderung wurde durch die
                  GSI SLV Duisburg professionell und zu unser vollsten
                  Zufriedenheit umgesetzt.`,
          personImgSrc: "/images/Passbild1.png",
          personName: "Herr Dipl.-Ing Andreas Bork",
          personTitle: "Fachbauleiter Qualitätssicherung",
          personCompany: "Uniper Technologies GmbH",
        },
        {
          mainImgSrcMb: "images/banner_references2-mb.jpg",
          mainImgStyleDt: {
            backgroundImage: "url('images/banner_references2.png')",
            backgroundPosition: "center center",
            backgroundSize: "contain",
            backgroundColor: "rgb(242, 247, 250)",
          },
          mainImgAlt: "GSB International",
          headline: "Aluminium- und Stahlbeschichtung",
          referenceText: `Als eine der führenden Qualitätsgemeinschaften ist eine
                  unabhängige Betriebsüberwachung essenziell für uns und unsere
                  Mitglieder. Die GSI SLV Duisburg ist dank ihrer Neutralität
                  und dem fachlich sehr gut qualifizierten Personal ein
                  zuverlässiger und gewissenhafter Partner für uns.`,
          personImgSrc: "/images/Passbild2.png",
          personName: "Herr Dipl.-Ing Werner Mader",
          personTitle: "Geschäftsführer",
          personCompany: "GSB International e.V.",
        },
        {
          mainImgSrcMb: "images/banner_references3-mb.jpg",
          mainImgStyleDt: {
            backgroundImage: "url('images/banner_references3_kleiner.png')",
          },
          mainImgAlt: "Energiewirtschaft",
          headline: "Energiewirtschaft",
          referenceText: `„Seit über zehn Jahren schult die GSI SLV unsere Mitarbeiter
                  und übernimmt aufgrund der guten Erfahrungen seit einigen
                  Jahren auch weitergehende Aufgaben der
                  Bau-/Fertigungsüberwachung im Bereich Schweißtechnik.“`,
          personImgSrc: "/images/Passbild3.png",
          personName: "Ulrike Schatz",
          personTitle: "Head of Corporate Quality <br> Management Systems",
          personCompany: "GNS Gesellschaft für <br> Nuklear-Service mbH",
        },
      ],
    };
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .reference-text {
    min-height: 220px;
    max-width: 475px;
  }
}
@media screen and (min-width: 768px) {
  .reference-text-container {
    justify-content: center;
  }
  .slide-img-dt {
    background-repeat: no-repeat;
    height: 100%;
    min-height: 400px;
    background-position: right top;
    background-size: cover;
  }
}
@media screen and (max-width: 767px) {
  .slide-img-dt {
    background-image: none !important;
  }
}
.slider-person-img img {
  width: 100px;
  height: auto;
}
@media screen and (min-width: 768px) {
  .slide-img-col {
    height: 100%;
  }
}
@media screen and (max-width: 985px) {
  .person-slider-info {
    font-size: 16px;
    line-height: 24px;
  }
}
@media screen and (max-width: 480px) {
  .person-slider-info {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
